const COLORS = [
  '#ff4d4f',
  '#ff7a45',
  '#ffa940',
  '#ffc53d',
  '#ffec3d',
  '#bae637',
  '#73d13d',
  '#36cfc9',
  '#40a9ff',
  '#597ef7',
  '#9254de',
  '#f759ab',
  '#d9d9d9',
];

export const getColor = (index: number): string => {
  return COLORS[index % COLORS.length]
};


// WEBPACK FOOTER //
// ./src/statistics/utils/statistics-colors.tsx